import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-4 text-start col-span-9" }
const _hoisted_2 = { class: "w-full h-full rounded-full bg-primary flex items-center justify-center" }
const _hoisted_3 = { class: "text-white font-bold" }
const _hoisted_4 = { class: "overflow-clip" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]

import { computed } from 'vue'
import { resolveAvatarSrc } from '@/utils/avatar'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  props: {
    doctor: {}
  },
  setup(__props: any) {

const props = __props;



const resolvedPhoto = computed(() => resolveAvatarSrc(props.doctor.photo))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProtectedAvatar, {
      src: resolvedPhoto.value,
      size: 64
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.doctor.name?.substring(0, 2).toUpperCase()), 1)
        ])
      ]),
      _: 1
    }, 8, ["src"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", {
        class: "font-bold truncate",
        title: _ctx.doctor.name
      }, _toDisplayString(_ctx.doctor.name), 9, _hoisted_5),
      _createElementVNode("p", {
        class: "truncate",
        title: _ctx.doctor.email
      }, _toDisplayString(_ctx.doctor.email), 9, _hoisted_6),
      _createElementVNode("p", null, _toDisplayString(_ctx.doctor.phone), 1)
    ])
  ]))
}
}

})